import { AxiosError } from 'axios';
import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from 'react-query';
import { api } from '../../../static/api';
import { QueryAliases } from '../../../types/QueryAliases';
import { CallbackDefault } from '../../../types/Types';
import { getApiErrorMessage } from '../../../utils/api/getApiErrorMessage';
import useAxiosInstance from '../../axios/useAxiosInstance';
import useToast from '../../useToast';

const useDeleteQuestion = ({ onSuccess }: { onSuccess?: CallbackDefault } = {}) => {
  const axiosInstance = useAxiosInstance();
  const queryClient = useQueryClient();
  const { showErrorToast } = useToast();
  const { t } = useTranslation();

  const { mutateAsync, isLoading } = useMutation(
    (id: string) => axiosInstance.delete(api.endpoints.SINGLE_QUESTION({ id })),
    {
      async onSuccess() {
        await queryClient.refetchQueries([QueryAliases.QUESTIONS]);

        if (!!onSuccess) {
          onSuccess();
        }
      },
      onError: (err: AxiosError) => {
        const errorMessage = getApiErrorMessage(err) ?? t('errorMessages.deleteQuestionFailed');

        showErrorToast(errorMessage);
      },
    },
  );

  return { deleteQuestion: mutateAsync, isLoading };
};

export default useDeleteQuestion;
